import { TableCell, TableRow } from '@mui/material';
import { styled } from '@mui/material/styles';

import { COLORS } from '../../../configs/colors';

export const HeadingCell = styled(TableCell)`
  font-weight: 600;
  white-space: nowrap;
`;

export const StyledTableRow = styled(TableRow)`
  background-color: ${COLORS.LightBackground1};
  position: sticky;
  top: 0;
`;